import React from "react";
import { Link } from "react-router-dom";
import { Home, ChevronLeft,} from "lucide-react";
import "./Breadcrumbs.css";

export default function Breadcrumbs({ items = [] }) {

     console.log('Breadcrumbs',items);

    return (

        <nav
            className="breadcrumbs-wrapper"
            aria-label="مسیر صفحه"
        >

            <div className="breadcrumbs">

                {/* Home */}

                <Link
                    to="/"
                    className="breadcrumb-home"
                >
                    <Home size={16} />

                    <span>
                        خانه
                    </span>
                </Link>


                {items.map((item) => (

                    <React.Fragment
                        key={`${item.type || "category"}-${item.id}`}
                    >

                        <ChevronLeft
                            className="breadcrumb-separator"
                            size={16}
                        />


                        <Link
                            to={item.url}
                            className={`
                                breadcrumb-link
                                ${item.type === "product"
                                    ? "breadcrumb-product"
                                    : ""
                                }
                            `}
                            title={item.name}
                        >
                            {item.name}
                        </Link>

                    </React.Fragment>

                ))}

            </div>

        </nav>

    );

}